import React from 'react'

import { BlockComponent } from 'common/builder/components/chart/FlowChart/components/Block/types'
import { ContentContainer } from 'common/builder/components/chart/FlowChart/components/ContentContainer/ContentContainer'
import { NoButtonStatContextProvider } from 'common/builder/components/chart/FlowChart/contexts/ButtonStatContext'
import { FlowChartTelegramKeyboardBlock } from 'common/builder/components/chart/FlowChart/types/FlowChartTelegramKeyboardBlock'

import * as styles from './Keyboard.styles'
import { KeyboardButton } from './KeyboardButton'

export const KeyboardTelegramBlock: BlockComponent<FlowChartTelegramKeyboardBlock> = (props) => {
  const { buttonRows } = props.block.data

  /**
   * Wrapping with empty ButtonStatContextProvider to prevent from
   * showing CTR on buttons in Telegram Keyboard
   */
  return (
    <NoButtonStatContextProvider>
      <ContentContainer>
        <richtext style={styles.Title} text={'Telegram Menu'} />

        {buttonRows.map((row, index) => (
          <view style={styles.RowWrapper} key={index}>
            {row.buttons.map((button, index) => (
              <KeyboardButton
                isFirst={index === 0}
                isLast={index === row.buttons.length - 1}
                button={button}
                key={button.id}
              />
            ))}
          </view>
        ))}
      </ContentContainer>
    </NoButtonStatContextProvider>
  )
}
